import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PriceProps from '../../../utils/prop-types/fuel-price';
import styles from './styles.css';
import { formatPrice } from './price-item';

const PostedPrice = ({ price, country }) => (
  <div>
    <div className={styles.priceItemPrice}>
      {`${country === 'USA' ? '$' : ''}${formatPrice(price.price, country)}`}
    </div>
    <div>
      <img
        src={`/images/stationProfile/v2/price-feed/${price.stamp}.png`}
        alt="Price Source Icon"
        width={14}
        height={14}
        className={styles.priceItemSourceIcon}
      />
      {price.nickname}
    </div>
    <div>{moment(price.posted_time).fromNow()}</div>
  </div>
);

PostedPrice.propTypes = {
  price: PriceProps.isRequired,
  country: PropTypes.string.isRequired,
};

export default PostedPrice;
